
    import { defineComponent, PropType, ref, Component } from 'vue';
    import { ILibraryComponentList } from '../library/types';

    export default defineComponent({
        name: "SingleFullPage",
        props: {
            componentName: { type: String, required: true },
            componentList: { type: Object as PropType<ILibraryComponentList>, required: true }
        },
        setup(props, _context) {
            let currentComponent = props.componentList.getAllComponents().filter(c => c.id == props?.componentName)[0] ?? null;

            return {
                currentComponent
            }
        }
    });
